import * as Sentry from "@sentry/vue";
import router from "@/router";
import type { Vue } from "@sentry/vue/types/types";

export const initSentry = (app: Vue) => { 
  if (import.meta.env.MODE === "localdev") {
    return;
  }

  Sentry.init({
    app,
    beforeSend (event) {
      const queryString = new URLSearchParams(window.location.search);
      const isAccessDeniedError = queryString.get("error") === "access_denied";
      if (isAccessDeniedError) {
        return null; 
      }
      if (
        event.request &&
        event.request.headers &&
        event.request.headers.authorization
      ) {
        delete event.request.headers.authorization;
      }
      return event;
    },
    dsn: import.meta.env.VITE_SENTRY_CLIENT_DSN,
    environment: import.meta.env.MODE,
    integrations: [
        Sentry.browserTracingIntegration({ router }),
    ], 
    tracePropagationTargets: [ window.location.origin, window.location.hostname, /^\// ],
    tracesSampleRate: 1.0,
  });

  Sentry.getCurrentScope().setTag("application", "frontend");
};
